import * as React from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

// export interface NumberInputProps {
// }

const currencySymbol = "$";

export const CurrencyInput = (props: { value: number, onValueChange: (v: number) => void }) => {

    const numberMask = createNumberMask({
        prefix: currencySymbol,
        suffix: ''
    })

    return <MaskedInput
        // {...props}
        maxLength={10}
        style={{ textAlign: "right" }}
        mask={numberMask}
        value={props.value || ""}
        // onFocus={e => props.onValueChange(0)}
        onChange={e => {
            console.log(">>>", e.target.value);
            const s = e.target.value
                .replace(/,/g, "")
                .replace(currencySymbol, "")
                .replace("%", "")
                ;
            const v = parseFloat(s) || 0;
            props.onValueChange(v);
        }}

    />

}